import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: "root"})
export class ImagePreviewService {

  public _imageSource = new BehaviorSubject<string>(null);

  openPreview(imageSource: any) {
    this._imageSource.next(imageSource)
  }

}
